import src from "IMAGE";
export default { src, width: 262, height: 63, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AMqtdcP83qX6u6BtgREQFhQDBQ8SDAsKDxoUBxEaFAcRAMqud8H84Kj4vaBtgBAQFRMDBQ4RCwoJDhcSBg8XEgYQGlMTMHWlvEwAAAAASUVORK5CYII="};
